export const NATIVE_TOKEN_ADDRESS = '0x0000000000000000000000000000000000000000';
